module.exports = __webpack_public_path__ + "img/onboarding-decoration-2.99f38f62.svg";